// src/components/common/LoadingState.jsx
import React from 'react';
import PropTypes from 'prop-types';
import { Box, CircularProgress, Typography } from '@mui/material';

/**
 * LoadingState - Consistent loading state component
 * Displays a centered loading spinner with optional message
 *
 * @component
 * @example
 * <LoadingState message="Loading employee data..." />
 */
const LoadingState = ({ message = 'Loading...', height = '300px' }) => {
  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
        height,
        gap: 2
      }}
    >
      <CircularProgress />
      {message && (
        <Typography variant="body2" color="text.secondary">
          {message}
        </Typography>
      )}
    </Box>
  );
};

LoadingState.propTypes = {
  /** Optional loading message */
  message: PropTypes.string,
  /** Height of loading container */
  height: PropTypes.string
};

export default LoadingState;
